import { Controller } from "@hotwired/stimulus"

// See Full Bio on a session page's speaker card (TMS-1615): swaps the short bio for the whole
// one in place, and back.
export default class extends Controller {
  static targets = ["short", "full", "toggle", "label"]

  toggle() {
    const expanded = this.fullTarget.hidden
    this.fullTarget.hidden = !expanded
    this.shortTarget.hidden = expanded
    this.toggleTarget.setAttribute("aria-expanded", String(expanded))
    this.labelTarget.textContent = expanded ? "Show Less" : "See Full Bio"
  }
}
